module.exports = __webpack_public_path__ + "static/media/img80_R.a6dee3cb.jpg";